const LOAD = 'LOAD';
const RESET_STATE = 'RESET_STATE';
const LOAD_ERROR = 'LOAD_ERROR';

export {
    LOAD,
    RESET_STATE,
    LOAD_ERROR,
};
